import { useEffect, useState } from "react";
import { Button, Snackbar } from "@mui/material";
import { Vocabulary } from "../Utils/Vocabulary";

export default function AppUpdateBanner() {
  const [waitingWorker, setWaitingWorker] = useState<ServiceWorker | null>(
    null
  );

  useEffect(() => {
    const handleSwUpdate = (event: Event) => {
      const registration = (event as CustomEvent<ServiceWorkerRegistration>)
        .detail;
      setWaitingWorker(registration.waiting);
    };

    window.addEventListener("swUpdate", handleSwUpdate);
    return () => window.removeEventListener("swUpdate", handleSwUpdate);
  }, []);

  const handleReload = () => {
    if (!waitingWorker) return;
    waitingWorker.postMessage({ type: "SKIP_WAITING" });
    waitingWorker.addEventListener("statechange", (e) => {
      if ((e.target as ServiceWorker).state === "activated") {
        window.location.reload();
      }
    });
  };

  return (
    <Snackbar
      open={!!waitingWorker}
      message={Vocabulary.newVersionAvailable}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
      action={
        <Button color="secondary" size="small" onClick={handleReload}>
          {Vocabulary.reload}
        </Button>
      }
    />
  );
}
